import { api } from "./api";

const KEY = "instabridge_admin";

export const saveAdmin = (data) => localStorage.setItem(KEY, JSON.stringify(data));
export const getAdmin = () => {
  try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
};
export const clearAdmin = () => localStorage.removeItem(KEY);

// Server-side session probe; httpOnly cookies are sent automatically.
// We preserve the access_token (Bearer fallback) since /me doesn't return it.
export const fetchAdminMe = async () => {
  const { data } = await api.get("/auth/me");
  const prev = getAdmin() || {};
  saveAdmin({ ...data, access_token: prev.access_token, refresh_token: prev.refresh_token });
  return data;
};

export const adminLogout = async () => {
  try { await api.post("/auth/logout"); } catch { /* ignore */ }
  clearAdmin();
};
